import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  ExpenseReportModel,
  ExpenseReportResponse,
} from 'src/models/expenseReport.model'
import {
  ExpenseReportMatchParams,
  expenseReportRouteProps,
  managerReviewReimbursementRouteProps,
  myWalletReimbursementRouteProps,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

export const selectManagerReviewExpenseReportIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<ExpenseReportMatchParams>(
      backgroundLocation.pathname,
      managerReviewReimbursementRouteProps,
    ) as match<ExpenseReportMatchParams>
    return mtch?.params?.id
  },
)

export const selectExpenseReportIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<ExpenseReportMatchParams>(
      backgroundLocation.pathname,
      expenseReportRouteProps,
    ) as match<ExpenseReportMatchParams>
    return mtch?.params?.id
  },
)

export const selectMyWalletReimbursementIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<ExpenseReportMatchParams>(
      backgroundLocation.pathname,
      myWalletReimbursementRouteProps,
    ) as match<ExpenseReportMatchParams>
    return mtch?.params?.id
  },
)

export const selectExpenseReportFromState = (
  state: RootState,
): ExpenseReportResponse | undefined => state.app.expenseReport.expenseReport

export const selectExpenseReportModelFromState = createSelector(
  [selectExpenseReportFromState],
  (expenseReport) =>
    expenseReport !== undefined
      ? new ExpenseReportModel(expenseReport)
      : undefined,
)

export const selectExpenseReportLoadedFromState = (state: RootState): boolean =>
  state.app.expenseReport.loaded

export const selectSubmittingExpenseReportFromState = (
  state: RootState,
): boolean => state.app.expenseReport.postSubmittingExpenseReport
export const selectSubmittingExpenseReportErrorFromState = (
  state: RootState,
): string | undefined =>
  state.app.expenseReport.postSubmittingExpenseReportError

export const selectResetBulkSelectFromState = (state: RootState): boolean =>
  state.app.expenseReport.resetBulkSelect
